import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Image, Carousel, Col, Row } from '@thd-olt-component-react/core-ui';
import { PackagesMiniContext } from '../PackagesMiniContext';
import { getPackageUrl } from '../../utils';
import './visual-product-images.scss';

const VisualProductImages = () => {
  const { channel } = useContext(ExperienceContext);
  const { products, packageModel } = useContext(PackagesMiniContext);
  const packageUrl = getPackageUrl(packageModel);
  const getImageUrl = (url) => url.replace(/1000(?=(.(jpg|webp)))/, '600');
  const slidesPerViewAndGroup = { slidesPerView: 2, slidesPerGroup: 2 };
  const isMobile = channel === 'mobile';
  const isHighFetchPriority = ({ index }) => {
    const maxIndex = isMobile ? 1 : 2;
    return index < maxIndex;
  };

  return (
    <Row data-testid="visual-product-images">
      <Col className="product-images__wrapper">
        <Carousel
          breakpoints={{
            sm: slidesPerViewAndGroup,
            md: slidesPerViewAndGroup,
            lg: slidesPerViewAndGroup,
            xl: slidesPerViewAndGroup
          }}
          slidesPerGroup={1}
          slidesPerView={1}
        >
          {products.map((product, index) => (
            <div
              data-testid="visual-product-image"
              className="product-images__image-item"
              key={`image-${product.itemId}`}
            >
              <a href={packageUrl}>
                <Image
                  src={getImageUrl(product?.media?.image?.url || '')}
                  alt="package product image"
                  stretchy
                  lazy={!isHighFetchPriority({ index })}
                  fetchpriority={isHighFetchPriority({ index }) ? 'high' : 'auto'}
                />
              </a>
            </div>
          ))}
        </Carousel>
      </Col>
    </Row>
  );
};

VisualProductImages.displayName = 'VisualProductImages';

export { VisualProductImages };